import { RotaBuilderFiltersType } from 'screens/Rostering/types'
import { BuilderFilters } from './BuilderFilters'
import { ShiftBuilderFilters } from './ShiftBuilderFilters'
import { User } from '@lmc/ts-common/lib/lists/User'
import { ResidentDtos } from '@lmc/ts-common'

type RotaFiltersProps = {
  value?: RotaBuilderFiltersType
  onChange?: (value: RotaBuilderFiltersType) => void
  builderType: 'user' | 'resident' | 'shift'
  users?: User[]
  residents?: ResidentDtos[]
}

export const RotaBuilderFilters = ({
  value,
  onChange,
  builderType,
}: RotaFiltersProps) => {
  switch (builderType) {
    case 'user':
      return <BuilderFilters value={value} onChange={onChange} builderType={builderType} />
    case 'resident':
      return <BuilderFilters value={value} onChange={onChange} builderType={builderType} />
    case 'shift':
      return <ShiftBuilderFilters value={value} onChange={onChange} />
    default:
      return null
  }
}
